import React from 'react';
import { useIntl } from 'ha/i18n';

import { Wrapper } from './Wrapper';
import { Variant } from './types';

const UserCardCountry: React.FC<{
  location: string;
  variant: Variant;
}> = ({ location, variant }) => {
  const { T } = useIntl();

  if (!location) {
    return null;
  }

  return (
    <Wrapper variant={variant} dataTestLocator="User Card Country">
      {T('from %s', location)}
    </Wrapper>
  );
};

export { UserCardCountry };
